"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var Observable_1 = require("rxjs/Observable");
require("./header.component.scss");
var header_settings_component_1 = require("./header-settings.component");
var user_help_item_model_1 = require("../../models/user-help-item.model");
var HeaderComponent = /** @class */ (function () {
    function HeaderComponent() {
        this.isView = false;
        this.isReadonly = false;
        this.workflowActions = [];
        // tslint:disable-next-line:no-output-on-prefix
        this.onWfSelect = new core_1.EventEmitter();
        this.editClick = new core_1.EventEmitter();
        this.cancelEvent = new core_1.EventEmitter();
        this.saveEvent = new core_1.EventEmitter();
        this.saveCloseEvent = new core_1.EventEmitter();
    }
    Object.defineProperty(HeaderComponent.prototype, "userHelpItemsAsObjects", {
        set: function (values) {
            this.userHelpItems = values ? values.map(user_help_item_model_1.userHelpItemFromObject) : [];
        },
        enumerable: true,
        configurable: true
    });
    HeaderComponent.prototype.getIsView = function () {
        return this.isView !== undefined ? this.isView : this.isReadonly;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], HeaderComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderComponent.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderComponent.prototype, "isView", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderComponent.prototype, "caption", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderComponent.prototype, "title_msg", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HeaderComponent.prototype, "userHelpItems", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], HeaderComponent.prototype, "userHelpItemsAsObjects", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HeaderComponent.prototype, "exportTemplates", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HeaderComponent.prototype, "workflowActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], HeaderComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderComponent.prototype, "labelMessage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HeaderComponent.prototype, "hasEditPermission", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HeaderComponent.prototype, "withDeleteButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HeaderComponent.prototype, "withEditButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HeaderComponent.prototype, "withCommentButton", void 0);
    __decorate([
        core_1.Input()
        // tslint:disable-next-line:no-any
        ,
        __metadata("design:type", Observable_1.Observable)
    ], HeaderComponent.prototype, "actionNotifier", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderComponent.prototype, "form", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderComponent.prototype, "formActions", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HeaderComponent.prototype, "onWfSelect", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HeaderComponent.prototype, "editClick", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HeaderComponent.prototype, "cancelEvent", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HeaderComponent.prototype, "saveEvent", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HeaderComponent.prototype, "saveCloseEvent", void 0);
    HeaderComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-header',
            template: require('./header.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n        <sis-header\n            [id]=\"'%{id}'\"\n            [entity]=\"entity\"\n            [categoryName]=\"category\"\n            [isView]=\"actions.isViewForm()\"\n            [caption]=\"category\"\n            [form]=\"form\"\n            [formActions]=\"actions\"\n            [userHelpItemsAsObjects]=\"%{userHelpItems}\"\n            [exportTemplates]=\"%{exportTemplates}\"\n            [workflowActions]=\"workflowActions\"\n            [currentLanguageId]=\"currentLanguageId\"\n            [labelMessage]=\"%{labelMessage}\"\n            [title_msg]=\"%{title_msg}\"\n            [withDeleteButton]=\"%{withDeleteButton}\"\n            [withEditButton]=\"%{withEditButton}\"\n            [withCommentButton]=\"%{withCommentButton}\"\n            [actionNotifier]=\"actionNotifier\"\n            [hasEditPermission]=\"%{hasEditPermission}\"\n            [isReadonly]=\"%{isReadonly}\"\n            (onWfSelect)=\"%{onWfSelect}\"\n            (editClick)=\"%{editClick}\"\n            (cancelEvent)=\"%{cancelEvent}\"\n            (saveEvent)=\"%{saveEvent}\"\n            (saveCloseEvent)=\"%{saveCloseEvent}\">\n        </sis-header>\n  ",
            settings: {
                main: header_settings_component_1.HeaderSettingsComponent,
            },
            isHeader: true,
            name: 'Desktop Header',
            nameKey: 'de.controls.desktop_header.title',
            defaultActions: {
                hasEditPermission: 'hasEditPermission',
                onWfSelect: 'onDoWorkflowAction',
                editClick: 'toDefaultEditForm',
                cancelEvent: 'onCancel',
                saveEvent: 'onSave',
                saveCloseEvent: 'onSaveAndClose',
            },
            isFieldBound: true,
        })
    ], HeaderComponent);
    return HeaderComponent;
}());
exports.HeaderComponent = HeaderComponent;
//# sourceMappingURL=header.component.js.map